import { LucideFacebook, LucideInstagram } from 'lucide-react';

export const AppFooter = ({ className = '' }: { className?: string }) => {
  return (
    <footer className={`relative border-t border-slate-200/70 bg-white/70 ${className}`.trim()}>
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 text-sm text-slate-500 sm:flex-row">
        <span>LeCartte © 2026</span>
        <div className="flex items-center gap-4">
          <a href="https://www.instagram.com/lecartte.app" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="transition hover:text-slate-700">
            <LucideInstagram />
          </a>
          <a href="https://www.facebook.com/share/17f3djLndC/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="transition hover:text-slate-700">
            <LucideFacebook />
          </a>
          <a href="https://x.com/lecartte" target="_blank" rel="noopener noreferrer" aria-label="X" className="transition hover:text-slate-700">
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};
